require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./storing-security-sensitive-data-using-aws-kms-and-openssl.json") })
        }
      }, "path---storing-security-sensitive-data-using-aws-kms-and-openssl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---storing-security-sensitive-data-using-aws-kms-and-openssl!./.cache/json/storing-security-sensitive-data-using-aws-kms-and-openssl.json
// module id = 337
// module chunks = 231608221292675